module.exports = __webpack_public_path__ + "static/media/m_sf_3.e098284a.png";